import React, { useState, useEffect, useCallback } from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';
import { useRouteMatch } from 'react-router-dom';

import useComponentMounted from '../../../hooks/useComponentMounted';
import CoachOnboarding from '../../Model/CoachOnboarding';
import LoadingOverlay from '../../components/LoadingOverlay';

import OnboardingTable from './components/OnboardingTable';
import NewCoachModal from './components/NewCoachModal';

import {
  Container,
  AddNewCoachButton,
  ButtonsContainer,
} from './styles';
import text from './text.json';

const CRXCoachOnboarding = () => {
  const [isReady, setIsReady] = useState(false);
  const [showAllOnboardings, setShowAllOnboardings] = useState(false);
  const [coachOnboardingCollection, setCoachOnboardingCollection] = useState({ docs: [] });
  const [isNewCoachModalOpen, setIsNewCoachModalOpen] = useState(false);

  const {
    params: {
      userId: crx,
    },
  } = useRouteMatch();

  const isComponentMountedRef = useComponentMounted();

  useEffect(() => {
    const getOnboardingDocs = async () => {
      const collection = showAllOnboardings
        ? await CoachOnboarding.getAllOnboardings()
        : await CoachOnboarding.getCoachesOnboardingByCrxId(crx);

      if (isComponentMountedRef.current) {
        setCoachOnboardingCollection(collection);
        setIsReady(true);
      }
    };
    if (!isReady) {
      getOnboardingDocs();
    }
  }, [
    isReady,
    isComponentMountedRef,
    showAllOnboardings,
    crx,
  ]);

  const onAddNewCoach = useCallback(async (
    email,
    name,
    primarySocial,
    primaryHandle,
    assignedCAM,
    assignedCPS,
    coachDriveFolder,
    launchDate,
  ) => {
    await CoachOnboarding.createNewCoachonboardingDoc(
      crx,
      email,
      name,
      primarySocial,
      primaryHandle,
      assignedCAM,
      assignedCPS,
      coachDriveFolder,
      launchDate,
    );
    if (isComponentMountedRef.current) {
      setIsNewCoachModalOpen(false);
    }
  }, [
    crx,
    isComponentMountedRef,
  ]);

  const handleShowAllOnboardings = useCallback((checked) => {
    setShowAllOnboardings(checked);
    setIsReady(false);
  }, []);

  return (
    <Container>
      <ButtonsContainer>
        <AddNewCoachButton
          variant="contained"
          onClick={() => setIsNewCoachModalOpen(true)}
        >
          {text.addNewCoach}
        </AddNewCoachButton>
      </ButtonsContainer>
      <OnboardingTable
        rows={coachOnboardingCollection.docs}
        showAllOnboardings={showAllOnboardings}
        handleCheckboxClick={handleShowAllOnboardings}
        onRefresh={() => setIsReady(false)}
      />
      <NewCoachModal
        isOpen={isNewCoachModalOpen}
        onDidDismiss={() => setIsNewCoachModalOpen(false)}
        onAddNewCoach={onAddNewCoach}
      />
      <LoadingOverlay isLoading={!isReady} />
    </Container>
  );
};

export default compose(
  observer,
)(CRXCoachOnboarding);
